import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const TikTokAds = () => {
  const pageData = {
    category: "TIKTOK ADS",
    title: "TikTok Ads Management",
    description: "Tap into the fastest-growing social platform with viral-ready short-form video campaigns. Our TikTok advertising specialists create authentic, trend-driven content that captures attention and drives conversions among Gen Z and millennial audiences.",

    features: [
      {
        title: "Viral Creative Production",
        description: "Authentic, trend-based video content that blends seamlessly into the TikTok feed and drives massive engagement."
      },
      {
        title: "In-Feed & TopView Ads",
        description: "Native ad placements that appear in users' For You feeds and premium first-impression TopView takeover ads."
      },
      {
        title: "Spark Ads & Branded Effects",
        description: "Amplify organic content performance and create custom filters, stickers, and effects that users love to share."
      },
      {
        title: "Influencer Collaboration",
        description: "Partner with TikTok creators who align with your brand to leverage their audiences and authentic influence."
      },
      {
        title: "Hashtag Challenge Campaigns",
        description: "Launch branded hashtag challenges that encourage user-generated content and drive viral engagement."
      },
      {
        title: "TikTok Pixel & Analytics",
        description: "Advanced tracking to measure views, engagement, conversions, and full-funnel attribution for e-commerce."
      }
    ],

    benefits: [
      {
        title: "Explosive Reach",
        description: "Access 1+ billion monthly active users with the highest engagement rates of any social platform."
      },
      {
        title: "Younger Demographics",
        description: "Dominate Gen Z and millennial markets with authentic, entertaining content they actually want to see."
      },
      {
        title: "Viral Potential",
        description: "Algorithm-driven discovery means even small accounts can achieve massive organic reach and virality."
      },
      {
        title: "Cost-Effective CPMs",
        description: "Lower cost per thousand impressions compared to traditional social platforms, maximizing ad spend efficiency."
      }
    ],

    process: [
      {
        title: "Trend Research & Strategy",
        description: "Analyze trending sounds, hashtags, and content formats to develop culturally relevant campaign strategies."
      },
      {
        title: "Creative Production",
        description: "Produce authentic, mobile-first video content that follows TikTok best practices and storytelling formats."
      },
      {
        title: "Campaign Launch & Testing",
        description: "Deploy campaigns with multiple creative variants and audience segments to identify winning combinations quickly."
      },
      {
        title: "Optimize & Scale",
        description: "Double down on high-performing creatives, refresh content regularly, and scale successful campaigns profitably."
      }
    ],

    relatedServices: [
      {
        title: "Meta Ads",
        description: "Expand social reach with Instagram Reels and Facebook campaigns",
        link: "/services/paid-ads/meta-ads"
      },
      {
        title: "Google Ads",
        description: "Capture search intent with Google YouTube campaigns",
        link: "/services/paid-ads/google-ads"
      },
      {
        title: "Video Production",
        description: "Professional video content creation services",
        link: "/services/web-development/custom-websites"
      }
    ],

    ctaText: "Ready to go viral and reach millions? Let's create TikTok campaigns that resonate with your audience.",
    ctaLink: "/contact",
    parentLink: "/services/paid-ads",
    parentTitle: "Paid Ads"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Tik Tok Ads Services" 
                description="Learn more about our Tik Tok Ads services to grow your business online with Digi Network." 
                canonical="/paid-ads/tik-tok-ads" 
            />

    </>
  );
};

export default TikTokAds;
